/**
 * Templates Page - Excel Templates Pack Download
 * Single pack download for registered users
 */

import { renderNavbar } from '../components/navbar.js';
import { renderFooter } from '../components/footer.js';
import { storage, isAuthenticated } from '../utils/storage.js';

const PACK_FILE = 'Plantillas_Financieras_Vivienda.xlsx';

export function renderTemplates(container) {

  container.innerHTML = `
    ${renderNavbar()}
    
    <main class="templates-page">
      <!-- Hero Section -->
      <section class="templates-hero">
        <div class="container">
          <div class="templates-hero-content animate-fadeIn">
            <span class="section-badge">📊 Plantillas Excel</span>
            <h1 class="templates-hero-title">
              Herramientas profesionales para 
              <span class="text-gradient">planificar tu hipoteca</span>
            </h1>
            <p class="templates-hero-subtitle">
              Pack completo diseñado por expertos financieros con todo lo que necesitas 
              para planificar la compra de tu vivienda.
            </p>
          </div>
        </div>
      </section>
      
      <!-- Pack Completo - Featured -->
      <section class="templates-section">
        <div class="container">
          <div class="pack-featured">
            
            <!-- Left: Info -->
            <div class="pack-info">
              <div class="pack-badge">
                <i data-feather="package"></i>
                Pack Completo
              </div>
              <h2 class="pack-title">Plantillas Finanzas Pro</h2>
              <p class="pack-description">
                Todo lo que necesitas para planificar la compra de tu vivienda en un solo archivo Excel profesional.
              </p>
              
              <div class="pack-includes">
                <h3>Incluye:</h3>
                <div class="pack-grid">
                  <div class="pack-item">
                    <div class="pack-item-icon">
                      <i data-feather="home"></i>
                    </div>
                    <div>
                      <strong>Calculadora de Hipoteca</strong>
                      <span>Cuota mensual, amortización y comparador de escenarios</span>
                    </div>
                  </div>
                  <div class="pack-item">
                    <div class="pack-item-icon">
                      <i data-feather="pie-chart"></i>
                    </div>
                    <div>
                      <strong>Planificador de Gastos</strong>
                      <span>Control de gastos, categorización y dashboard mensual</span>
                    </div>
                  </div>
                  <div class="pack-item">
                    <div class="pack-item-icon">
                      <i data-feather="trending-up"></i>
                    </div>
                    <div>
                      <strong>Simulador de Ahorro</strong>
                      <span>Objetivo configurable, proyección temporal y seguimiento</span>
                    </div>
                  </div>
                  <div class="pack-item">
                    <div class="pack-item-icon">
                      <i data-feather="columns"></i>
                    </div>
                    <div>
                      <strong>Comparador de Hipotecas</strong>
                      <span>Compara hasta 5 bancos, TAE real y gastos ocultos</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Right: Download Card -->
            <div class="pack-download-card">
              <div class="pack-download-inner">
                <div class="pack-icon-large">
                  <i data-feather="file-text"></i>
                </div>
                <div class="pack-file-name">Plantillas_Financieras_Vivienda.xlsx</div>
                <div class="pack-file-meta">
                  <span><i data-feather="layers"></i> 4 plantillas</span>
                  <span><i data-feather="check-circle"></i> Excel & Google Sheets</span>
                </div>
                
                <div class="pack-price-tag">
                  <span class="pack-price">Gratis</span>
                  <span class="pack-price-sub">para usuarios registrados</span>
                </div>
                
                <button class="btn btn-primary btn-lg w-full pack-download-btn" id="downloadPackBtn">
                  <i data-feather="download"></i>
                  Descargar gratis
                </button>
                
                <div class="pack-guarantee">
                  <i data-feather="shield"></i>
                  Compatible con Excel y Google Sheets
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- Features strip -->
      <section class="pack-features-strip">
        <div class="container">
          <div class="features-strip-grid">
            <div class="feature-strip-item">
              <i data-feather="zap"></i>
              <span>Descarga instantánea</span>
            </div>
            <div class="feature-strip-item">
              <i data-feather="refresh-cw"></i>
              <span>Actualizaciones gratuitas</span>
            </div>
            <div class="feature-strip-item">
              <i data-feather="monitor"></i>
              <span>Excel & Google Sheets</span>
            </div>
            <div class="feature-strip-item">
              <i data-feather="help-circle"></i>
              <span>Soporte incluido</span>
            </div>
          </div>
        </div>
      </section>
      
      <!-- FAQ -->
      <section class="templates-faq">
        <div class="container">
          <h2 class="section-title" style="text-align: center; margin-bottom: 48px;">
            Preguntas frecuentes
          </h2>
          
          <div class="faq-grid">
            <div class="faq-item">
              <h3>¿Necesito registrarme para descargar?</h3>
              <p>Sí, solo necesitas crear una cuenta gratuita para acceder a las plantillas.</p>
            </div>
            <div class="faq-item">
              <h3>¿Funcionan en Google Sheets?</h3>
              <p>Sí, las plantillas son compatibles con Microsoft Excel y Google Sheets.</p>
            </div>
            <div class="faq-item">
              <h3>¿Se actualizan las plantillas?</h3>
              <p>Sí, se actualizan periódicamente con mejoras y nuevas funcionalidades.</p>
            </div>
            <div class="faq-item">
              <h3>¿Puedo usarlas en el móvil?</h3>
              <p>Sí, puedes abrirlas con la app de Excel o Google Sheets en tu móvil o tablet.</p>
            </div>
          </div>
        </div>
      </section>
      
    </main>
    
    ${renderFooter()}
    
    <style>
      .templates-page {
        padding-top: 72px;
      }
      
      .templates-hero {
        background: 
          radial-gradient(circle at 20px 20px, var(--primary-100) 2px, transparent 0),
          linear-gradient(135deg, var(--primary-50) 0%, white 100%);
        background-size: 40px 40px, 100% 100%;
        padding: var(--space-20) 0;
      }
      
      .templates-hero-content {
        text-align: center;
        max-width: 700px;
        margin: 0 auto;
      }
      
      .templates-hero-title {
        font-size: clamp(2rem, 4vw, 3rem);
        margin-bottom: var(--space-4);
      }
      
      .templates-hero-subtitle {
        font-size: var(--font-size-lg);
        color: var(--gray-600);
        margin-bottom: var(--space-6);
      }
      
      /* Pack Featured Layout */
      .templates-section {
        padding: var(--space-16) 0;
      }
      
      .pack-featured {
        display: grid;
        grid-template-columns: 1.4fr 1fr;
        gap: 48px;
        align-items: start;
      }
      
      .pack-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: var(--primary-100);
        color: var(--primary-700);
        padding: 8px 16px;
        border-radius: var(--radius-full);
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 20px;
      }
      
      .pack-badge svg {
        width: 16px;
        height: 16px;
      }
      
      .pack-title {
        font-size: clamp(1.8rem, 3vw, 2.5rem);
        font-weight: 800;
        margin-bottom: 12px;
        color: var(--gray-900);
      }
      
      .pack-description {
        font-size: var(--font-size-lg);
        color: var(--gray-600);
        margin-bottom: 32px;
        line-height: 1.6;
      }
      
      .pack-includes h3 {
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 1px;
        color: var(--gray-500);
        margin-bottom: 16px;
      }
      
      .pack-grid {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
      
      .pack-item {
        display: flex;
        align-items: flex-start;
        gap: 14px;
        padding: 16px;
        background: var(--gray-50);
        border-radius: var(--radius-lg);
        transition: var(--transition-fast);
      }
      
      .pack-item:hover {
        background: var(--primary-50);
        transform: translateX(4px);
      }
      
      .pack-item-icon {
        width: 40px;
        height: 40px;
        min-width: 40px;
        background: white;
        border-radius: var(--radius-md);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--primary-600);
        box-shadow: 0 1px 3px rgba(0,0,0,0.08);
      }
      
      .pack-item-icon svg {
        width: 18px;
        height: 18px;
      }
      
      .pack-item strong {
        display: block;
        font-size: 15px;
        margin-bottom: 2px;
        color: var(--gray-900);
      }
      
      .pack-item span {
        font-size: 13px;
        color: var(--gray-500);
        line-height: 1.4;
      }
      
      /* Download Card */
      .pack-download-card {
        position: sticky;
        top: 100px;
      }
      
      .pack-download-inner {
        background: white;
        border: 2px solid var(--gray-200);
        border-radius: var(--radius-2xl);
        padding: 32px;
        text-align: center;
        box-shadow: var(--shadow-xl);
        transition: var(--transition-base);
      }
      
      .pack-download-inner:hover {
        border-color: var(--primary-300);
        box-shadow: 0 20px 60px rgba(26, 82, 118, 0.15);
      }
      
      .pack-icon-large {
        width: 72px;
        height: 72px;
        background: linear-gradient(135deg, var(--primary-500), var(--primary-700));
        border-radius: var(--radius-xl);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 16px;
        color: white;
      }
      
      .pack-icon-large svg {
        width: 32px;
        height: 32px;
      }
      
      .pack-file-name {
        font-family: 'SF Mono', Monaco, monospace;
        font-size: 13px;
        color: var(--gray-500);
        background: var(--gray-50);
        padding: 6px 12px;
        border-radius: var(--radius-md);
        display: inline-block;
        margin-bottom: 20px;
      }
      
      .pack-file-meta {
        display: flex;
        justify-content: center;
        gap: 20px;
        margin-bottom: 24px;
        font-size: 13px;
        color: var(--gray-500);
      }
      
      .pack-file-meta span {
        display: flex;
        align-items: center;
        gap: 6px;
      }
      
      .pack-file-meta svg {
        width: 14px;
        height: 14px;
        color: var(--success);
      }
      
      .pack-price-tag {
        margin-bottom: 24px;
      }
      
      .pack-price {
        font-size: 36px;
        font-weight: 800;
        color: var(--success);
        display: block;
      }
      
      .pack-price-sub {
        font-size: 13px;
        color: var(--gray-500);
      }
      
      .pack-download-btn {
        font-size: 16px;
        padding: 16px;
      }
      
      .pack-guarantee {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        margin-top: 16px;
        font-size: 12px;
        color: var(--gray-500);
      }
      
      .pack-guarantee svg {
        width: 14px;
        height: 14px;
        color: var(--success);
      }
      
      /* Features strip */
      .pack-features-strip {
        background: var(--gray-50);
        padding: var(--space-10) 0;
        border-top: 1px solid var(--gray-200);
        border-bottom: 1px solid var(--gray-200);
      }
      
      .features-strip-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 24px;
      }
      
      .feature-strip-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        font-size: 14px;
        font-weight: 500;
        color: var(--gray-700);
      }
      
      .feature-strip-item svg {
        width: 18px;
        height: 18px;
        color: var(--primary-600);
      }
      
      /* FAQ */
      .templates-faq {
        padding: var(--space-16) 0;
      }
      
      .faq-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: var(--space-6);
      }
      
      .faq-item {
        background: var(--gray-50);
        padding: var(--space-6);
        border-radius: var(--radius-lg);
      }
      
      .faq-item h3 {
        font-size: var(--font-size-base);
        margin-bottom: var(--space-2);
        color: var(--gray-900);
      }
      
      .faq-item p {
        color: var(--gray-600);
        font-size: var(--font-size-sm);
      }
      
      @media (max-width: 968px) {
        .pack-featured {
          grid-template-columns: 1fr;
        }
        
        .pack-download-card {
          position: static;
        }
        
        .features-strip-grid {
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }
      }
      
      @media (max-width: 768px) {
        .faq-grid {
          grid-template-columns: 1fr;
        }
        
        .features-strip-grid {
          grid-template-columns: 1fr;
        }
      }
    </style>
  `;

  // Initialize download button
  initDownloadButton();
}

function initDownloadButton() {
  const btn = document.getElementById('downloadPackBtn');
  if (!btn) return;

  btn.addEventListener('click', () => {
    const originalText = btn.innerHTML;

    try {
      btn.disabled = true;
      btn.innerHTML = '<span class="spinner-sm"></span> Descargando...';

      // Create hidden link and trigger download
      const link = document.createElement('a');
      link.href = '/templates/' + PACK_FILE;
      link.download = PACK_FILE;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Show success
      setTimeout(() => {
        btn.innerHTML = '<i data-feather="check"></i> ¡Descargado!';
        btn.style.background = 'var(--success)';
        if (window.feather) window.feather.replace();

        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = originalText;
          btn.style.background = '';
          if (window.feather) window.feather.replace();
        }, 3000);
      }, 500);

    } catch (error) {
      console.error('Download error:', error);
      btn.disabled = false;
      btn.innerHTML = originalText;
      if (window.feather) window.feather.replace();
    }
  });
}
